import { render, staticRenderFns } from "./DiagnosticsBadge.vue?vue&type=template&id=76d40260&scoped=true"
import script from "./DiagnosticsBadge.vue?vue&type=script&lang=js"
export * from "./DiagnosticsBadge.vue?vue&type=script&lang=js"
import style0 from "./DiagnosticsBadge.vue?vue&type=style&index=0&id=76d40260&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76d40260",
  null
  
)

export default component.exports